<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="passwordForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
				<p-tag icon="pi cm-alert" [value]="('PASSWORD_WARNING_INFO' | translate)" severity="warning"></p-tag>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.PasswordOld, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordOld, 'label')">{{ 'OLD_PASSWORD' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordOld, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="settings-password"
							formControlName="PasswordOld" autocomplete="mtma-contact-add-input-name"
							placeholder="{{ 'OLD_PASSWORD' | translate }}" [maxlength]="lengthPassword" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.PasswordOld)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'AUTOMATION_PASSWORD_NUMBER' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.PasswordNew, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordNew, 'label')">{{ 'NEW_PASSWORD' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordNew, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="settings-password"
							formControlName="PasswordNew" autocomplete="mtma-contact-add-input-name"
							placeholder="{{ 'NEW_PASSWORD' | translate }}" [maxlength]="lengthPassword" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.PasswordNew)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'AUTOMATION_PASSWORD_NUMBER' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-8 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>